<script setup lang="ts">
import {computed} from "vue";
import {COLOR_PICKER_NONE_COLOR_VALUE} from "@/lib/constants/colors";

interface CustomColorChipProps {
  color: string;
  isSelected?: boolean;
  isBordered?: boolean;
}

const props = defineProps<CustomColorChipProps>();

const chipColor = computed<string>(
  () =>
    `rgb(var(--v-theme-${
      props.color === COLOR_PICKER_NONE_COLOR_VALUE
        ? "newLayerBackground"
        : props.color
    }))`,
);
</script>

<template>
  <v-chip
    :color="chipColor"
    :class="{
      selected: isSelected,
      bordered: isBordered,
      default: color === COLOR_PICKER_NONE_COLOR_VALUE,
    }"
    class="custom-color-chip"
    size="small"
    variant="flat"
  />
</template>

<style scoped lang="scss">
.custom-color-chip {
  --bordered-padding: 0 12px;

  padding: 0 calc(var(--v-chip-height) / 2);
  cursor: pointer;

  &.bordered {
    border: 1px solid rgb(var(--v-theme-newSelected)) !important;
    // removes the border width from the original padding ($chip-padding)
    padding: var(--bordered-padding);
  }

  &.selected {
    position: relative;
    overflow: visible;

    &::after {
      content: "";
      position: absolute;
      width: 32px;
      height: 32px;
      left: 50%;
      top: 50%;
      background: transparent;
      transform: translate(-50%, -50%);
      border: 2px solid rgb(var(--v-theme-newPrimaryRegular));
      border-radius: 50%;
    }
  }

  &.default {
    padding: var(--bordered-padding);
    border: 1px solid rgb(var(--v-theme-grey-200));

    &::before {
      content: "";
      position: absolute;
      height: 100%;
      width: 1px;
      background: rgb(var(--v-theme-red-600));
      top: 0;
      left: 50%;
      transform: rotate(45deg);
    }
  }
}
</style>
